import { render, staticRenderFns } from "./ReportButtons.vue?vue&type=template&id=286c00bf&"
import script from "./ReportButtons.vue?vue&type=script&lang=js&"
export * from "./ReportButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
